import React from 'react';
import { Box, Table } from '@mantine/core';
import { moneyFormat, centsToDollars } from '@/helpers/money';
import { DeliveryEventVendorFinancialDetails } from '../types';

export const DeliveryFinancial: React.FC<DeliveryEventVendorFinancialDetails> = ({
  summaryOrderCount,
  summaryItemCount,
  summaryFoodSalesCents,
  summaryTaxCents,
  summaryTaxRemittedByFoodaCents,
  summaryCommissionCents,
  summaryPpFeesCents,
  summaryPreliminaryEventTotalCents,
}) => {

  const displayMoney = (moneyInCents: number): string => moneyFormat(centsToDollars(moneyInCents));

  return (
    <Box bdrs="md" bd="1px solid var(--mantine-color-gray-4)" style={{ overflow: 'hidden' }}>
      <Table fz="sm" withRowBorders={false}>
        <Table.Caption pl="xs" pr="xs" mb="xs">
          <sup>&lowast;</sup>This table is for reference only and subject to change pending refunds or other adjustments. Finalized order financials are represented on the Finance Statement
        </Table.Caption>
        <Table.Thead>
          <Table.Tr style={{ borderBottom: '1px solid var(--mantine-color-gray-4)' }}>
            <Table.Th colSpan={2}>Financial Summary</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td colSpan={2} fw="bold">
              {summaryOrderCount} order{summaryOrderCount === 1 ? '' : 's'} with {summaryItemCount} total item{summaryItemCount === 1 ? '' : 's'}<sup>&lowast;</sup>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>Food Sales</Table.Td>
            <Table.Td ta="right">{displayMoney(summaryFoodSalesCents)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>Tax</Table.Td>
            <Table.Td ta="right">{displayMoney(summaryTaxCents)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td pl="lg">Tax Remitted by Fooda</Table.Td>
            <Table.Td ta="right">({displayMoney(summaryTaxRemittedByFoodaCents)})</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>Commission</Table.Td>
            <Table.Td ta="right">({displayMoney(summaryCommissionCents)})</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>PP Fees</Table.Td>
            <Table.Td ta="right">({displayMoney(summaryPpFeesCents)})</Table.Td>
          </Table.Tr>
          <Table.Tr fw="bold" style={{ borderBottom: '1px solid var(--mantine-color-gray-4)' }}>
            <Table.Td>Preliminary Total</Table.Td>
            <Table.Td ta="right">{displayMoney(summaryPreliminaryEventTotalCents)}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Box>
  );
};
